/**
 * Who belongs in the list you are looking at.
 *
 * Extracted from EmployeesTable so the rule can be tested without a screen, and
 * so the next entity-scoped list uses the same one rather than inventing a
 * second opinion. The audit found several lists that ought to scope and do not;
 * this is what they should reach for when they do.
 *
 * Three scopes, and the interesting one is the third:
 *
 *   entity      only people in the entity you are working in
 *   unassigned  only people in no entity at all
 *   all         everyone in the organisation
 *
 * "Unassigned" exists because the two obvious rules are both wrong. Hiding
 * unplaced people everywhere makes the record that needs fixing the one you
 * cannot open. Showing them in every entity states something false — it is why
 * the owner of an organisation, who belongs to no entity in particular,
 * appeared as staff of all of them. A bucket is visible without being a claim.
 */

const unitsOf = (person) => ((person && person.legalUnit) || []).map(String);

export const SCOPES = ["entity", "unassigned", "all"];

export const inEntityScope = (person, scope, activeEntityId) => {
  if (scope === "all") return true;
  const units = unitsOf(person);
  if (scope === "unassigned") return units.length === 0;
  // No entity selected yet — nothing to narrow by, so narrow to nothing would
  // be an empty screen with no way to explain itself.
  if (!activeEntityId) return true;
  return units.includes(String(activeEntityId));
};

/**
 * How many people each scope would show, for the labels on the control. An
 * empty bucket should be visibly empty rather than something you have to open
 * to rule out.
 */
export const scopeCounts = (people = [], activeEntityId) => {
  let inEntity = 0;
  let unassigned = 0;
  people.forEach((person) => {
    const units = unitsOf(person);
    if (units.length === 0) unassigned += 1;
    else if (activeEntityId && units.includes(String(activeEntityId))) inEntity += 1;
  });
  return { inEntity, unassigned, all: people.length };
};
